import gql from 'graphql-tag';

const attachmentQueries = {

    allAttachmentTypes: gql`
        query Attachmenttypes {
          attachmenttypes(count: 100, orderBy: [{ field: "name", order: ASC }]) {
            data {
              id
              name
              color
              priority
              auto_select_by
            }
          }
        }
    `,

    findAttachmentReference: gql `
        query Attachment($id: ID) {
            attachment(id: $id) {
                file_id
                attachmentReferences {
                    attachment_id
                    project_id
                    building_id
                    contract_id
                }
            }
        }
    `,
};

export default attachmentQueries;
